import Layout from '@/layout/index.vue'

// GIMMATEK 會員模組只保留會員管理、會員卡面設定；LINE 好友狀態列表、會員等級相關設定不提供（CNCY-10766）
export default [
  {
    path: '/members',
    component: Layout,
    // 服務人員只有會員管理一頁，仍顯示「顧客模組」群組（CNCY-10961）
    alwaysShow: true,
    isGroup: true,
    name: 'Members',
    meta: {
      title: 'page.member.title',
    },
    children: [
      {
        path: 'members-manage',
        name: 'MembersManage',
        component: () => import('@/views/Members/MembersManage/MembersManage.vue'),
        meta: {
          title: 'page.membersManage.title',
          action: 'admin.member.page',
          bobPageAction: 'PAGE_VIEW_DASH_SHOP_MEMBER_LIST',
        },
      },
      {
        path: 'member-profile/:id/:tab?',
        name: 'MemberProfile',
        hidden: true,
        component: () => import('@/views/Members/MemberProfile'),
        meta: {
          title: 'page.memberProfile.title',
          action: 'admin.member.page',
        },
      },
      {
        path: 'member-create',
        name: 'MemberCreate',
        hidden: true,
        component: () =>
          import('@/views/Members/MemberCreate/MemberCreate.vue'),
        meta: {
          title: 'page.memberCreate.title',
          action: 'admin.member.page',
        },
      },
      {
        path: 'member-card-setting',
        name: 'MemberCardSetting',
        component: () =>
          import('@/views/MemberCardSetting/MemberCardSetting.vue'),
        meta: {
          title: 'page.memberCardSetting.title',
          action: 'admin.customCardTemplate.page',
        },
      },
      {
        path: 'member-card-edit/:styleName?/:id?',
        name: 'MemberCardEdit',
        hidden: true,
        component: () =>
          import('@/views/MemberCardSetting/components/MemberCardEdit.vue'),
        meta: {
          title: 'page.memberCardSetting.title',
          action: 'admin.customCardTemplate.page',
        },
      },
    ],
  },
]
